export default [
  {
    iconSrc: "https://static.bigbrain.gg/assets/ugg/pages/landing/patch-report-icon.svg",
    iconWidth_Large: 64,
    iconWidth_Normal: 63,
    header: "Patch Report",
    description: "Track your LP gain by each champion you play.",
    shortDescription: "Track your LP gain by each champion you play.",
  },
  {
    iconSrc: "https://static.bigbrain.gg/assets/ugg/pages/landing/icon-yir.svg",
    iconWidth_Large: 70,
    iconWidth_Normal: 63,
    header: "2020 Year in Review",
    description: "Generated upon signup and it's yours forever.",
    shortDescription: "Generated upon signup and it's yours forever.",
  },
  {
    iconSrc: "https://static.bigbrain.gg/assets/ugg/pages/landing/icon-adfree.svg",
    iconWidth_Large: 64,
    iconWidth_Normal: 63,
    header: "Ad-Free Experience",
    description: "Experience faster load times and cleaner UI (Desktop only).",
    shortDescription: "Experience faster load times and cleaner UI (Desktop only).",
  },
  {
    iconSrc: "https://static.bigbrain.gg/assets/ugg/pages/landing/icon-combo.svg",
    iconWidth_Large: 64,
    iconWidth_Normal: 63,
    header: "Combos",
    description: "Master basic trading to highlight reel combos with video breakdowns.",
    shortDescription: "Master basic to highlight reel combos with video breakdowns.",
  },
  {
    iconSrc: "https://static.bigbrain.gg/assets/ugg/pages/landing/icon-customize.svg",
    iconWidth_Large: 64,
    iconWidth_Normal: 63,
    header: "Customized Profiles",
    description: "Unlock champion backgrounds for your profile, plus track achievements.",
    shortDescription: "Unlock champion backgrounds for your profile.",
  },
  {
    iconSrc: "https://static.bigbrain.gg/assets/ugg/pages/landing/boost-db-icon.svg",
    iconWidth_Large: 64,
    iconWidth_Normal: 63,
    header: "BOOST Dashboard",
    description: "Advanced analytics of every match you play.",
    shortDescription: "Advanced analytics of every match you play.",
    comingSoon: true,
  },
];
